export const sctmKeys = {
  all: ["sctm"] as const,
  sctm: (sctm: string) => [...sctmKeys.all, sctm] as const,
};
